import * as actionsTypes from "./actionTypes";

const getMeetingRoomProviderList = filter => ({
    type: actionsTypes.GET_MEETING_ROOM_PROVIDER_LIST_REQUEST,
    filter
});

const searchMeetingRooms = searchFields => ({
    type: actionsTypes.MEETING_ROOM_SEARCH_REQUEST,
    searchFields
});

const getMeetingRoomData = meetingRoomId => ({
    type: actionsTypes.GET_MEETING_ROOM_REQUEST,
    meetingRoomId
});

const createMeetingRoom = meetingRoomData => ({
    type: actionsTypes.CREATE_MEETING_ROOM_REQUEST,
    meetingRoomData
});

const editMeetingRoom = (meetingRoomId, meetingRoomData) => ({
    type: actionsTypes.EDIT_MEETING_ROOM_REQUEST,
    meetingRoomId,
    meetingRoomData
});

const deleteMeetingRoom = meetingRoomId => ({
    type: actionsTypes.DELETE_MEETING_ROOM_REQUEST,
    meetingRoomId
});

const resetMeetingRoomsForm = () => ({
    type: actionsTypes.RESET_MEETING_ROOMS_FORM
});

const getScheduledEventsForCalendar = (meetingRoomId, start, end) => ({
    type: actionsTypes.GET_SCHEDULED_EVENTS_FOR_CALENDAR_REQUEST,
    meetingRoomId,
    start,
    end
});

const searchScheduleEventEntries = searchFields => ({
    type: actionsTypes.SCHEDULE_EVENT_ENTRIES_SEARCH_REQUEST,
    searchFields
});

export default {
    getMeetingRoomProviderList,
    getScheduledEventsForCalendar,
    searchMeetingRooms,
    getMeetingRoomData,
    createMeetingRoom,
    editMeetingRoom,
    deleteMeetingRoom,
    resetMeetingRoomsForm,
    searchScheduleEventEntries
}